import { all, fork } from 'redux-saga/effects';
import baseModule from './baseModuleList';
import baseModuleForm from './baseModuleForm';

export default all([
  fork(baseModule),
  fork(baseModuleForm),
]);



// WEBPACK FOOTER //
// ./src/sagas/baseModules/index.js